import { VEHICLE_ONLINE, VEHICLE_OFFLINE, VEHICLE_INACTIVE } from '@/config/tackingConfig'

export let state = {
    devicesInactive: 0,
    devicesOnline: 0,
    devicesOffline: 0,
    journeyVehicles: [],
    trackingVehicles: [],
    subscribedVehiclesFleetCounter: {},
    filters: [
        VEHICLE_ONLINE,
        VEHICLE_OFFLINE,
        VEHICLE_INACTIVE
    ],
    showIdlePoints: true,
    showRawData: false,
    showSpeedingData: true,
    centerCar: null,
    // vehicleJourney: null,
    // journeysData: null,
    activeJourneys: [],
    currentJourney: null,
    selectedJourneys: [],
    currentVehicle: null,
    activeTab: null,
    // isJourneyLoading: false,
    // availableJourneysTypes: [],
    deviceStatistics: [],
    eventFilters: [],
    eventClassifications: [],
    isLoading: false,
    isTrackingAsideLoading: false,
    isJourneyTabActive: false,
    openAutoJourney: true,
    dateInJourneyTab: null,
    updatedSharedEvent: null,
    isClusteringActive: true,
    isOpenActionJourneyTab: false,
    lastActiveDate: null
};
